import { render, staticRenderFns } from "./JeecgOrderMainList.vue?vue&type=template&id=2801c62a&scoped=true&"
import script from "./JeecgOrderMainList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderMainList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderMainList.vue?vue&type=style&index=0&id=2801c62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801c62a",
  null
  
)

export default component.exports